import { useQuery as useTanStackQuery } from '@tanstack/react-query';

import { getUnautheticatedUser } from 'services/RequestService/endpoints/signUp';

const useFetchFunnelUser = mealPlan => {
  return useTanStackQuery({
    queryKey: ['funnel_user', { mealPlan }],
    queryFn: ({ queryKey }) => {
      const [, { mealPlan }] = queryKey;
      return getUnautheticatedUser({ params: { user: { mealPlanSlug: mealPlan } } });
    },
    staleTime: 1000 * 60 * 10, // Read from cache for 10 minutes
    enabled: mealPlan !== null, // Only run the query if mealPlan is not null
  });
};

export default useFetchFunnelUser;
